import Swiper, { Navigation, Pagination } from "swiper"
Swiper.use([Navigation, Pagination])
export default new (class EditorContentCarousel {
    constructor() {
        this.sliderContainerSelector = "carousel-editor-content"
        this.sliderNextSelector = "carousel-editor-content-next"
        this.sliderPrevSelector = "carousel-editor-content-prev"
        this.sliderPaginationSelector = "carousel-editor-content-pagination"
        this.handler()
    }

    handler() {
        const slider = document.querySelector(`.${this.sliderContainerSelector}`)

        if (!slider) return

        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.${this.sliderContainerSelector}`).forEach((item) => {
            const swiper = new Swiper(item, {
                slidesPerView: 1,
                spaceBetween: 16,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                pagination: {
                    el:  item.parentElement.querySelector(`.${this.sliderPaginationSelector}`),
                    type: "fraction",
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                                ' из ' +
                                '<span class="' + totalClass + '"></span>';
                    },
                },
                centerInsufficientSlides: true,
            })

            if (item.querySelector('[data-signature]')) {
                swiper.on('slideChange', () => {
                    item.querySelector('.slider-signature').innerHTML = swiper.slides[swiper.activeIndex].dataset.signature;
                })
            }
        })
    }
})()
